import axios from "axios";
import React, { useState, useEffect } from "react";
import profile from "../../assets/images/profile.jpg";
import { APIURL } from "../../redux/action/config";
import dateFormat from "dateformat";
import { Formik } from "formik";
import { updateAddress } from "../../redux/action/customers";
import { useDispatch } from "react-redux";
import Autocomplete from "react-google-autocomplete";

const UpdateAddress = (props) => {
  const dispatch = useDispatch();
  const [location, setLocation] = useState();
  const [city, setCity] = useState();
  const [state, setState] = useState();
  const [lat, setLat] = useState();
  const [lon, setLon] = useState();
  const data = location?.formatted_address?.split(",");
  const userID = props.userID;
  const addId = props.addId;
  const allData = props.data;
  return (
    <React.Fragment>
      <div
        className="modal fade"
        id={props.modalId}
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header border-0 d-flex">
              <div className="text-center">
                <h1 className=" text-primary">Update Address</h1>
              </div>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="col-xl-12">
                <div className="fs-6 fw-bold mt-2 mb-3">Enter a location</div>
              </div>
              <Autocomplete
                apiKey={"AIzaSyBVq1YHt0rZrbQGLXL9CdL2VeU9kjtfO4I"}
                style={{ width: "100%" }}
                onPlaceSelected={(place) => {
                  place.address_components.forEach((component) => {
                    if (component.types.includes("locality")) {
                      setCity(component.long_name);
                    } else if (
                      component.types.includes("administrative_area_level_1")
                    ) {
                      setState(component.long_name);
                    }
                  });
                  setLocation(place);
                  setLat(place.geometry.location.lat());
                  setLon(place.geometry.location.lng());
                }}
                componentRestrictions={{ country: "bs" }}
                options={{
                  types: ["(cities)"],
                  // types: ["geocode", "establishment"],
                  componentRestrictions: { country: "bs" },
                }}
                className="form-control form-control-solid"
                placeholder="Enter Your Address"
              />
              <div className="modal-body p-0">
                <Formik
                  initialValues={{
                    street: data?.[0],
                    appartment: data?.[1],
                    city: data?.[2],
                    lat: lat,
                    lon: lon,
                  }}
                  onSubmit={(values) => {
                    values.address = location?.formatted_address || allData?.address;
                    values.city = data?.[2];
                    values.lat = lat ?? allData?.lat;
                    values.lon = lon ?? allData?.long;
                    dispatch(updateAddress(values, userID, addId));
                  }}
                >
                  {({ values, handleBlur, handleChange, handleSubmit }) => (
                    <form className="form">
                      <div className="row mb-2 mt-5">
                        {/* <div className="col-xl-12">
                          <div className="fs-6 fw-bold mt-2 mb-3">Street</div>
                        </div> */}
                        <div className="col-xl-12 fv-row fv-plugins-icon-container">
                          <input
                            type="text"
                            className="form-control form-control-solid"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="street"
                            id="street"
                            defaultValue={
                              city ? city : allData?.street_no
                            }
                          />
                          <div className="fv-plugins-message-container invalid-feedback"></div>
                        </div>
                      </div>
                      <div className="row mb-2">
                        {/* <div className="col-xl-12">
                          <div className="fs-6 fw-bold mt-2 mb-3">
                            Appartment, Building
                          </div>
                        </div> */}
                        <div className="membership-form-check col-xl-12 fv-row fv-plugins-icon-container d-flex flex-wrap checkbox">
                          <input
                            type="text"
                            className="form-control form-control-solid"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="appartment"
                            id="appartment"
                            defaultValue={
                              state ? state : allData?.address
                            }
                          />
                        </div>
                      </div>
                      <div className="row mb-2">
                        <div className="col-xl-12 fv-row fv-plugins-icon-container">
                          <textarea
                            rows="3"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="city"
                            id="city"
                            className="form-control form-control-solid"
                            defaultValue={data?.[2] ? data?.[2] : allData?.city}
                            disabled
                          ></textarea>
                          <div className="fv-plugins-message-container invalid-feedback"></div>
                        </div>
                      </div>
                      <div className="mb-6"></div>
                      <div className="d-flex justify-content-end">
                        <button
                          onClick={handleSubmit}
                          type="submit"
                          className="btn btn-primary"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        >
                          <span className="indicator-label">Save</span>
                        </button>
                      </div>
                    </form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default UpdateAddress;
